import React from 'react';
import ColoringApp from './components/ColoringApp';

function App() {
  return (
    <div className="App">
      <ColoringApp />
    </div>
  );
}

export default App;